export const oneHourInMilliseconds = 60 * 60 * 1000
export const oneDayInMilliseconds = oneHourInMilliseconds * 24

export const nameOfMonths = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
